module.exports = __webpack_public_path__ + "res/img/error.648ed5e0.png";